import { Button, Spacing, Stack, styled } from 'ui';

export const StyledStack = styled(Stack)`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;

export const DefaultButton = styled(Button)({
  height: '56px',
  minWidth: '56px',
});
